<template>
  <div class="gmf-timer gmf-text-small">
    <div class="gmf-timer-icon">
      <svg class="gmf-timer-content" viewBox="0 0 20 20">
        <circle class="gmf-timer-fill" r="5" cx="10" cy="10" fill="none"
                stroke-width="10"
                pathLength="100"
                :stroke-dashoffset="offset"
                stroke-dasharray="110px"
                style="transform-origin: center; transform:rotate(270deg)"/>
      </svg>
    </div>
    <div class="gmf-timer-text">{{ timeLeft }} {{ t('t_remaining') }}</div>
  </div>
</template>

<style>
.gmf-timer {
  display: flex;
  align-items: center;
}
.gmf-timer-icon {
  width: 14px;
  height: 14px;
  border-radius: 100%;
  border: 1px solid var(--gmf-icon-color);
  position: relative;
  line-height: 0 !important;
}
.gmf-timer-content {
  position: absolute;
  inset: 0;
  border: 1px solid transparent;
  border-radius: 100%;
}
.gmf-timer-fill {
  stroke: var(--gmf-icon-color);
}
.gmf-timer-text {
  margin-left: var(--gmf-p-2);
}
</style>

<script>
import secondsToHr from '@/utils/secondsToHr';
import state from '@/state';

export default {
  props: {
    time: {
      type: Number,
      required: true,
    },
    passedTime: {
      default: 0,
      type: Number,
      required: false,
    },
  },
  methods: {
    t: state.t,
  },
  computed: {
    offset () {
      const v = this.passedTime;
      const range = this.time;
      return '-' + ((v / range) * 100) + 'px';
    },
    timeLeft () {
      return secondsToHr(this.time - this.passedTime);
    },
  },
};
</script>
